import { GatePass } from '../_models/gate_pass';

import { GuardianService } from '../_services/guardian.service';
import { AuthService } from '../_services/auth.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";

@Injectable()
export class StudentAndGuardianShowGuard {

    constructor(
        private router: Router,
        private guardianService:GuardianService,
        private authService: AuthService) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {

        let server_student_user_id = undefined
        if(route.paramMap.get('server_student_user_id')){
          server_student_user_id=+route.paramMap.get('server_student_user_id')
        }
        let gatePass=this.authService.gatePass.getValue()

        let userIds = this.guardianService.getStudentUserIds()
        let ok = this.isStudentOrGuardian(gatePass,userIds,server_student_user_id)
        if(ok){
            return true
        }else{
            this.router.navigate(['/notfound'])
            return false
        }
    }
     isStudentOrGuardian(gatePass:GatePass,userIds:Array<number>, server_student_user_id:number){
      let ok1 = gatePass.is_role_guardian && userIds.includes(server_student_user_id)
      let ok2 = gatePass.is_role_admin
      let ok3 = gatePass.is_role_student && server_student_user_id== gatePass.user_id

      return ok1||ok2||ok3

     }

}
